import { render, staticRenderFns } from "./bindByPhone.vue?vue&type=template&id=15070523"
import script from "./bindByPhone.vue?vue&type=script&lang=js"
export * from "./bindByPhone.vue?vue&type=script&lang=js"
import style0 from "./bindByPhone.vue?vue&type=style&index=0&id=15070523&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports